import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { ButtonModule, JfDialogDirectives } from '@adnova/jf-ng-components';

import { DeleteAnnouncementDialogActions } from './+store/delete-announcement-dialog.actions';
import { DeleteAnnouncementDialogSelectors } from './+store/delete-announcement-dialog.selectors';

/**
 * Dialog-Komponente für das Löschen eines Announcements.
 *
 * Verwendet jf-lib Dialog-Direktiven für konsistentes Styling.
 * Der Dialog-State wird über NgRx verwaltet.
 */
@Component({
  selector: 'app-delete-announcement-dialog',
  standalone: true,
  imports: [CommonModule, ButtonModule, JfDialogDirectives],
  templateUrl: './delete-announcement-dialog.component.html',
  styleUrls: ['./delete-announcement-dialog.component.scss'],
})
export class DeleteAnnouncementDialogComponent {
  private readonly _store = inject(Store);

  /** Das zu löschende Item (Signal). */
  protected readonly itemToDelete$$ = this._store.selectSignal(
    DeleteAnnouncementDialogSelectors.itemToDelete,
  );

  /**
   * Bestätigt das Löschen des Items.
   */
  doConfirm(): void {
    this._store.dispatch(DeleteAnnouncementDialogActions.confirm());
  }

  /**
   * Bricht den Löschvorgang ab und schließt den Dialog.
   */
  doCancel(): void {
    this._store.dispatch(DeleteAnnouncementDialogActions.close());
  }
}
